import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  actionButton: {
    color: theme.palette.primary.light,
    fontWeight: 500,
    fontSize: '14px',
    fontFamily: 'Roboto',
    textTransform: 'none',
    paddingLeft: '0',
    '& svg': {
      transition: '0.1s ease-in-out',
    },
    '&:focus': {
      color: theme.palette.secondary.dark,
    },
    '&:hover': {
      color: theme.palette.primary.main,
      '& svg': {
        transform: 'translateX(4px)',
      },
    },
    '&:active': {
      color: theme.palette.primary.lightest,
    },
  },
}))

export default useStyles
